var green = {
  100: '#EFFCF0',
  200: '#D6F9DA',
  300: '#BEF5C8',
  400: '#90E8A9',
  500: '#69D28F',
  600: '#4AB075',
  700: '#2F8255',
  800: '#194C32',
  900: '#081911'
};
export default green;